import type { PropsWithChildren, ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Type } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import TruncatedTextWithTooltip from "app/pages/sales-intelligence/common-components/TruncatedText/TruncatedTextWithTooltip";

import { StyledTopCompanyLogo, TOP_COMPANY_HEADER_GAP, TOP_COMPANY_TEXT_SHIFT } from "./styles";

interface IProps {
    favicon: string;
    companyName: string;
    overviewLink: string;
    onOverviewClick: (event: React.MouseEvent<HTMLSpanElement>) => void;
}

const TopCompanyHeader = ({
    favicon,
    companyName,
    overviewLink,
    onOverviewClick,
    children,
}: PropsWithChildren<IProps>): ReactElement => {
    return (
        <Flex
            gap={`${TOP_COMPANY_HEADER_GAP}px`}
            alignItems="center"
        >
            <StyledTopCompanyLogo
                iconType={Type.Website}
                iconSrc={favicon}
            />
            <Flex
                gap="4px"
                flexDirection="column"
                maxWidth={`calc(100% - ${TOP_COMPANY_TEXT_SHIFT}px)`}
            >
                <a
                    href={overviewLink}
                    target="_blank"
                >
                    <TruncatedTextWithTooltip
                        fontVariant="subtitle1"
                        color={colorsPalettes.blue[400]}
                        onClick={onOverviewClick}
                    >
                        {companyName}
                    </TruncatedTextWithTooltip>
                </a>

                {children}
            </Flex>
        </Flex>
    );
};

export default TopCompanyHeader;
